<template>
  <div :class="tabSearch ? 'tab-search' : ''" class="z-search">
    <el-form :inline="true">
      <!-- <el-row :gutter="16"> -->
      <template v-for="(i, ti) in list">
        <!-- <el-col :lg="8" :xl="6" :md="8" :sm="8" :key="i.key"> -->
        <el-form-item
          :key="i.key"
          :label="i.label || ''"
          class="tab-item"
          v-show="!showNumCheck || ti + 1 <= numLength"
        >
          <slot :name="i.key">
            <component
              :is="i.componentType"
              class="input-item"
              v-bind="i.componentData"
              v-if="i.componentType && i.bindName"
              v-model.trim="form[i.bindName]"
              v-on="i.$listeners"
            />
            <component
              :is="i.componentType"
              class="input-item"
              v-bind="i.componentData"
              v-if="i.componentType && !i.bindName"
              v-model.trim="form"
              v-on="i.$listeners"
            />
          </slot>
        </el-form-item>
        <!-- </el-col> -->
      </template>
      <div style="display: inline-block">
        <el-form-item :label-width="labelWidth" label>
          <el-button
            :loading="loading"
            @click="query"
            type="primary"
            v-if="showConfirm"
          >{{ $t('system::common::btn::search') }}</el-button>
          <template v-if="showReset">
            <el-button @click="reset">{{ $t('system::common::btn::reset') }}</el-button>
          </template>
        </el-form-item>
      </div>
      <!-- </el-row> -->
      <span
        @click="showMore(list.length === numLength)"
        class="show-more-btn"
        v-if="showNumCheck && numLength !== 0 && list.length >= numLength"
      >
        <i :class="list.length === numLength ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </span>
      <!-- <el-button
        class="show-more-btn"
        v-if="showNumCheck && numLength !== 0"
        @click="showMore(list.length === numLength)"
        :icon="list.length === numLength ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
      ></el-button>-->
      <!-- <el-button v-if="showNumCheck && numLength !== 0" type="text" @click="showMore(list.length === numLength)">
          {{ list.length === numLength ? '收起' : '展开' }}
      </el-button>-->
    </el-form>
  </div>
</template>
<script>
import selectDatepicker from './select-datepicker'
import selectInput from './select-input'
import numberRange from './number-range'
const componentMap = {
  input: 'el-input',
  select: 'z-select',
  datePicker: 'el-date-picker',
  dict: 'dict-select',
  selectDatepicker: 'z-select-datepicker',
  selectInput: 'z-select-input',
  numberRange: 'z-number-range',
  cascader: 'el-cascader'
}

export default {
  name: 'ZSearch',
  components: {
    'z-select-datepicker': selectDatepicker,
    'z-select-input': selectInput,
    'z-number-range': numberRange
  },
  props: {
    configs: {
      type: Array,
      default: () => []
    },
    value: {},
    showReset: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      default: '70px'
    },
    showNum: {
      default: 4,
      type: Number
    },
    showNumCheck: {
      default: true,
      type: Boolean
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    usefulKeys: {
      type: Array
    },
    init: {
      type: Function
    },
    excludeValue: {
      type: [Array, Function],
      default () {
        return ['', null, undefined]
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Object
    },
    isResetDoReloadData: {
      type: Boolean,
      default: true
    },
    tabSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {},
      numLength: this.showNum,
      defaultVal: {}
    }
  },
  computed: {
    list () {
      return this.configs.map(item => {
        const data = { ...item }
        const { searchType } = data
        const component = componentMap[searchType]
        if (component) {
          data.componentType = component
        }
        data.componentData = Object.assign({
          popperAppendToBody: false,
          appendToBody: false,
        }, data.componentData)


        if (searchType && !['selectInput', 'selectDatepicker', 'numberRange'].includes(searchType)) {
          data.bindName = data.key
        }
        if (searchType === 'selectInput' && Array.isArray(data.key)) {
          const tmp = {
            selectKey: data.key[0],
            inputKey: data.key[1]
          }

          data.componentData = Object.assign({}, tmp, data.componentData)
        }
        if (searchType === 'numberRange' && Array.isArray(data.key)) {
          const tmp = {
            startKey: data.key[0],
            endKey: data.key[1]
          }
          data.componentData = Object.assign({

          }, tmp, data.componentData)
        }
        if (Array.isArray(data.key)) {
          data.key = data.key.join('-')
        }
        return data
      })
    },
    excludeValueFn () {
      let fn = val => false
      if (typeof this.excludeValue === 'function') {
        fn = this.excludeValue
      }
      if (Array.isArray(this.excludeValue)) {
        fn = val => this.excludeValue.includes(val)
      }
      return fn
    }
  },
  watch: {
    form: {
      handler (val) {
        this.list.forEach(item => {
          if (item.searchType === 'selectInput') {
            if (val[item.componentData.selectKey]) {
              val[val[item.componentData.selectKey]] = val[item.componentData.inputKey] || ''
            }
          }
        })
        this.$emit('input', val)
      },
      deep: true
    },
    value: {
      handler (val) {
        this.form = val
      },
      immediate: true
    }
  },
  created () {
    try {
      this.defaultVal = JSON.parse(JSON.stringify(this.defaultValue || this.value))
    } catch (e) {}
  },
  mounted () {
    if (typeof this.init === 'function') {
      const data = this.getSearchParams()
      this.init(data)
    }
  },
  methods: {
    getSearchParams (params) {
      const data = {}
      params = params || this.form

      let keys = Object.keys(params)
      if (Array.isArray(this.usefulKeys) && this.usefulKeys.length) {
        keys = this.usefulKeys
      }
      keys.forEach(key => {
        if (!this.excludeValueFn(params[key])) {
          data[key] = params[key]
        }
      })
      return data
    },
    query () {
      const data = this.getSearchParams()
      this.$emit('do-query', data)
    },
    showMore (bool) {
      if (bool) {
        this.numLength = this.showNum
        return
      }
      this.numLength = this.list.length
    },
    reset () {
      const data = JSON.parse(JSON.stringify(this.defaultVal))
      if (this.isResetDoReloadData) {
        const postData = this.getSearchParams(data)
        this.$emit('do-query', postData)
      }
      this.$emit('input', data)
      this.$emit('do-reset', data)
    }
  }
}
</script>
<style lang="scss">
.z-search {
  position: relative;
  background: #fff;
  border-radius: 12px;
  margin: 0;
  box-sizing: border-box;
  // padding: 16px;
  padding-bottom: 0;
  &::after {
    content: ' ';
    clear: both;
    display: inline-block;
  }
  &.tab-search {
    margin: 0;
    padding: 0;
    border-radius: 0;
  }

  .el-form-item {
    // width: 100%;
    // display: flex;
    margin-bottom: 10px;
  }
  .el-form-item__label {
    width: auto;
    flex: 0 0 auto;
    flex-wrap: nowrap;
    text-align: right;
  }
  .el-form-item__content {
    width: auto;
    flex: 1 1 auto;
  }

  .input-item {
    width: 100%;
  }
  .el-input-number {
    width: 100%;
  }
  .show-more-btn {
    position: absolute;
    bottom: -16px;
    left: 50%;
    width: 60px;
    height: 14px;
    margin-left: -30px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-radius: 13px 13px 0px 0px;
    border: 1px solid #e4e7edde;
    cursor: pointer;
  }
}
</style>
